import React, { useState } from 'react';
import closeSprite from 'assets/icons/close.svg';
import Button from 'components/Button';
import Countdown from 'components/Countdown';
import style from './style.css';

export default closeButton;

function closeButton(props) {
  const { onClick, skipTime, duration, hidden, paused } = props;

  if (isNaN(skipTime)) {
    return null;
  }

  if (skipTime >= duration) {
    return null;
  }

  const [clickable, setClickable] = useState(skipTime === 0);
  const makeClickable = () => setClickable(true);

  return clickable ? (
    <Button
      className={style.closeButton}
      onClick={onClick}
      icon={closeSprite.id}
      iconSize={26}
      aria-label="close"
      hidden={hidden}
    />
  ) : (
    <Countdown startFrom={skipTime} onComplete={makeClickable} paused={paused}>
      {() => null}
    </Countdown>
  );
}
